import { useEffect, useState } from "react";
import api from "../../api/api";
import "./TodoCard.css";

const TodoCard = () => {
  const [todos, setTodos] = useState([]);
  const [text, setText] = useState("");

  const fetchTodos = async () => {
    try {
      const res = await api.get("/todos");
      setTodos(Array.isArray(res.data) ? res.data : []);
    } catch {
      setTodos([]);
    }
  };

  useEffect(() => { fetchTodos(); }, []);

  const addTodo = async () => {
    if (!text.trim()) return;
    try {
      const res = await api.post("/todos", { text });
      setTodos([res.data, ...todos]);
      setText("");
    } catch { }
  };

  const toggleTodo = async (id) => {
    try {
      const res = await api.patch(`/todos/${id}`);
      setTodos(todos.map(t => t._id === id ? res.data : t));
    } catch { }
  };

  const deleteTodo = async (id) => {
    try {
      await api.delete(`/todos/${id}`);
      setTodos(todos.filter(t => t._id !== id));
    } catch { }
  };

  return (
    <div className="todo-card">
      <h3>Today's Tasks</h3>
      <p className="todo-subtitle">A simple todo improves your consistency</p>

      <div className="todo-input">
        <input
          type="text"
          value={text}
          maxLength={200}
          placeholder="Add a task..."
          onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => { if (e.key === "Enter") addTodo(); }}
        />
        <button onClick={addTodo}>Add</button>
      </div>

      <div className="todo-list">
        {todos.map((todo) => (
          <div key={todo._id} className="todo-item">
            <input
              type="checkbox"
              checked={todo.completed}
              onChange={() => toggleTodo(todo._id)}
            />
            <span className={todo.completed ? "done" : ""}>{todo.text}</span>
            <button onClick={() => deleteTodo(todo._id)}>✕</button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodoCard;